mutation EntityTagPurchaseOrderCreate(
  $input: EntityTagPurchaseOrderCreateInput!
) {
  entityTagPurchaseOrderCreate(input: $input) {
    entityTags {
      id
      tagId
      entityId
      appId
    }
  }
}
